import React from 'react';

const AIRLINES = [
  { code: 'AI', name: 'Air India' },
  { code: 'IndiGo', name: 'IndiGo' },
  { code: '6E', name: 'IndiGo' },
  { code: 'SG', name: 'SpiceJet' },
  { code: 'UK', name: 'Vistara' },
  { code: 'IX', name: 'Air Asia' },
  { code: 'AA', name: 'American' },
  { code: 'DL', name: 'Delta' },
  { code: 'UA', name: 'United' },
  { code: 'EK', name: 'Emirates' },
  { code: 'QR', name: 'Qatar' },
  { code: 'SQ', name: 'Singapore' },
  { code: 'LH', name: 'Lufthansa' },
  { code: 'BA', name: 'British' },
];

export default function AirlineStrip() {
  return (
    <div className="bg-white border-b border-gray-100 py-6 sm:py-8 overflow-hidden">
      <p className="text-center text-xs font-bold text-gray-400 uppercase tracking-widest mb-5">
        Book flights with 100+ airlines including
      </p>
      <div className="relative">
        <div className="flex gap-4 sm:gap-6 animate-none overflow-x-auto scrollbar-hide px-4 sm:px-8 pb-1"
          style={{ scrollbarWidth: 'none' }}>
          {[...AIRLINES, ...AIRLINES].map((airline, i) => (
            <div key={i}
              className="flex-shrink-0 flex flex-col items-center gap-2 group"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-violet-50 to-amber-50 border border-gray-100 flex items-center justify-center shadow-sm group-hover:shadow-md group-hover:border-violet-200 transition-all">
                <img
                  src={`https://www.gstatic.com/flights/airline_logos/70px/${airline.code}.png`}
                  alt={airline.name}
                  className="w-8 h-8 object-contain"
                  onError={e => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <span className="hidden w-full h-full items-center justify-center text-xs font-black text-violet-700">
                  {airline.code}
                </span>
              </div>
              <span className="text-xs text-gray-400 font-medium">{airline.name}</span>
            </div>
          ))}
        </div>
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-white to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>
    </div>
  );
}
